module.exports = __webpack_public_path__ + "static/media/MASTERCARD.5eac3404.svg";